/* ==========================================================================
   TRACKING LOADER
   --------------------------------------------------------------------------
   You do not need to edit this file. It reads your IDs from config.js.

   Nothing loads while the IDs are still placeholders, so the page stays
   fast and no broken requests are made.
   ========================================================================== */

(function () {
  'use strict';

  var C = window.TRA_CONFIG || {};
  window.dataLayer = window.dataLayer || [];

  // A value counts as "not set yet" if it is empty or still contains X's.
  function isSet(value) {
    return typeof value === 'string' && value.length > 0 && value.indexOf('X') === -1;
  }

  window.TRA_TRACKING = { gtm: false, ads: false, ga4: false };

  /* ---- Google Tag Manager ---- */
  if (isSet(C.GOOGLE_TAG_MANAGER_ID)) {
    window.TRA_TRACKING.gtm = true;
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var gtm = document.createElement('script');
    gtm.async = true;
    gtm.src = 'https://www.googletagmanager.com/gtm.js?id=' + C.GOOGLE_TAG_MANAGER_ID;
    document.head.appendChild(gtm);
  }

  /* ---- Google Ads and GA4 direct tags ---- */
  var adsOn = isSet(C.GOOGLE_ADS_CONVERSION_ID);
  var ga4On = isSet(C.GA4_MEASUREMENT_ID);

  if (adsOn || ga4On) {
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());

    var firstId = adsOn ? C.GOOGLE_ADS_CONVERSION_ID : C.GA4_MEASUREMENT_ID;
    var tag = document.createElement('script');
    tag.async = true;
    tag.src = 'https://www.googletagmanager.com/gtag/js?id=' + firstId;
    document.head.appendChild(tag);

    if (adsOn) {
      window.TRA_TRACKING.ads = true;
      // allow_enhanced_conversions lets Google Ads use the hashed email
      // and phone we send on the thank-you page.
      window.gtag('config', C.GOOGLE_ADS_CONVERSION_ID, { allow_enhanced_conversions: true });
    }
    if (ga4On) {
      window.TRA_TRACKING.ga4 = true;
      window.gtag('config', C.GA4_MEASUREMENT_ID);
    }
  }

  /* ---- Shared event helper, used by main.js ---- */
  window.traTrack = function (event, params) {
    var payload = { event: event };
    if (params) {
      for (var k in params) {
        if (Object.prototype.hasOwnProperty.call(params, k)) payload[k] = params[k];
      }
    }
    window.dataLayer.push(payload);

    // Mirror the same event into GA4 when Tag Manager is not being used.
    if (window.TRA_TRACKING.ga4 && !window.TRA_TRACKING.gtm && typeof window.gtag === 'function') {
      window.gtag('event', event, params || {});
    }
  };

})();
